import { render, staticRenderFns } from "./NewRentalScreen.vue?vue&type=template&id=f84ab670&scoped=true"
import script from "./NewRentalScreen.vue?vue&type=script&lang=js"
export * from "./NewRentalScreen.vue?vue&type=script&lang=js"
import style0 from "./NewRentalScreen.vue?vue&type=style&index=0&id=f84ab670&prod&scoped=true&lang=css"
import style1 from "./NewRentalScreen.vue?vue&type=style&index=1&id=f84ab670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84ab670",
  null
  
)

export default component.exports